module.exports = __webpack_public_path__ + "img/huanghou.b234ab76.jpg";